import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';

import {
  InputField,
  CheckBox,
  FormSectionTitle,
  Separator,
  SearchableSelect,
  Select
} from '../../../../components/form';
import getLangData from '../../../../utils/getLangData';
import ModerationForm from '../../../../components/form/ModerationForm';

import { applicantByIdSelector } from '../../../../modules/applicantsModearion/applicants/Selectors';

import {
  getSinglePendingApplicantAction,
  moderateCreateSinglePendingApplicantAction,
  updatePendingApplicantAction,
  getPendingApplicantsAction
} from '../../../../modules/applicantsModearion/applicants/Actions';
import { applicantsIsLoadingSelector } from '../../../../modules/applicants/Selectors';

import { pendingApplicantsIsLoadingSelector } from '../../../../modules/applicantsModearion/applicants/Selectors';

const options = [
  { value: ['0'], label: 'Individual' },
  { value: ['1'], label: 'Company' }
];

const ApplicantsForm = props => {
  const {
    getApplicant,
    moderationId,
    applicantId,
    applicant,
    updatePendingApplicant,
    applicantsIsLoading,
    pendingApplicantsIsLoading,
    moderateCreatePendingApplicant,
    getApplicants
  } = props;

  useEffect(() => {
    // getApplicant(applicantId);
    getApplicants();
  }, [getApplicant, applicantId]);

  console.log(applicant, 'applicantapplicant');
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...applicant }}
      onSubmit={values => {
        moderateCreatePendingApplicant(
          {
            id: applicantId
          },
          values.moderationType
        );
      }}
    >
      {({ handleSubmit }) => (
        <ModerationForm
          heading={
            applicant
              ? getLangData().buttons.update
              : getLangData().buttons.create
          }
          handleSubmit={handleSubmit}
          isLoading={applicantsIsLoading || pendingApplicantsIsLoading}
        >
          <FormSectionTitle>{getLangData().tables.basic_info}</FormSectionTitle>
          {console.log(applicant?.picture, 'applicant.picture')}
          {applicant?.picture && (
            <img
              src={applicant?.picture}
              style={{ width: '150px', height: '150px', borderRadius: '50%' }}
            />
          )}
          <InputField
            label={getLangData().fields.name}
            // name={applicant.userData[0].firstName}
            name='name'
          />
          <InputField
            label={getLangData().fields.bio}
            // name={applicant.userData[0].firstName}
            name='applicantBIO'
          />
          <InputField
            label={getLangData().fields.yearsOfExperience}
            // name={applicant.userData[0].firstName}
            name='yearsOfExperience'
          />{' '}
          <InputField
            label={getLangData().fields.skills}
            // name={applicant.userData[0].firstName}
            name='skillsTrans'
          />
          {/*
          {/* <SearchableSelect
            name='userID'
            label='User'
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
          /> */}
          {/* <InputField label='Business Name' name='businessName' />
          <Select
            options={options}
            name='applicantType'
            label='Applicant Type'
            inArray={true}
          />
          <Separator />
          <FormSectionTitle>Company :</FormSectionTitle>
          <InputField name='yearEstablished' label='Year Established' />
          <CheckBox
            name='regCompany'
            label='Registered Company'
            subLabel='I have Registered Company.'
          />{' '}
          <InputField label='Company Size' name='companySize' />
          <Separator /> */}
        </ModerationForm>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const applicantId = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    moderationId,
    applicantId,
    applicant: applicantByIdSelector(state, applicantId),
    applicantsIsLoading: applicantsIsLoadingSelector(state),

    pendingApplicantsIsLoading: pendingApplicantsIsLoadingSelector(state)
  };
};

const mapDispatchToProps = {
  getApplicant: getSinglePendingApplicantAction,
  moderateCreatePendingApplicant: moderateCreateSinglePendingApplicantAction,
  getApplicants: getPendingApplicantsAction
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicantsForm);
